export const SECTOR_SETTING_KEY = {
  SWITCH_TIME: 'visu_switch_time_ms'
};